import { AffiliateMemberCertification } from 'types'

export function higestUserCredential(
  certifications: AffiliateMemberCertification[],
): AffiliateMemberCertification {
  const certs = certifications?.filter(
    (c) =>
      ['OL1', 'L1', 'L2', 'L3', 'L4'].includes(c.level) &&
      new Date() < new Date(c.expiration),
  )
  if (certs.map((c) => c.level).includes('L4')) {
    return certs
      .filter((c) => c.level === 'L4')
      .sort((c1, c2) => {
        return new Date(c1.expiration) < new Date(c2.expiration) ? 1 : -1
      })[0]
  }

  if (certs.map((c) => c.level).includes('L3')) {
    return certs
      .filter((c) => c.level === 'L3')
      .sort((c1, c2) => {
        return new Date(c1.expiration) < new Date(c2.expiration) ? 1 : -1
      })[0]
  }

  if (certs.map((c) => c.level).includes('L2')) {
    return certs
      .filter((c) => c.level === 'L2')
      .sort((c1, c2) => {
        return new Date(c1.expiration) < new Date(c2.expiration) ? 1 : -1
      })[0]
  }

  if (certs.map((c) => c.level).includes('L1')) {
    return certs
      .filter((c) => c.level === 'L1')
      .sort((c1, c2) => {
        return new Date(c1.expiration) < new Date(c2.expiration) ? 1 : -1
      })[0]
  }

  if (certs.map((c) => c.level).includes('OL1')) {
    return certs
      .filter((c) => c.level === 'OL1')
      .sort((c1, c2) => {
        return new Date(c1.expiration) < new Date(c2.expiration) ? 1 : -1
      })[0]
  }
}
